module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "housekeeping"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md10": "",
      "text-xs-left": "",
      "pl-3": ""
    }
  }, [_c('p', [_vm._v("Estados de habitaciones:")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "search",
    attrs: {
      "md2": "",
      "text-xs-right": ""
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Buscar huésped, habitaciones…"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("search")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "state-room",
    attrs: {
      "text-xs-left": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "no-show",
    attrs: {
      "md3": "",
      "id": "1"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("No Show")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "check-inn",
    attrs: {
      "md3": "",
      "id": "2"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("Check in")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "checkout",
    attrs: {
      "id": "3"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("Check Out")])])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-layout', {
    staticClass: "state-room",
    attrs: {
      "justify-end": ""
    }
  }, [_c('v-flex', [_c('div', {
    staticClass: "icon maintenance"
  }), _vm._v(" "), _c('span', [_vm._v("Mantenimiento")])]), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "icon clean-bussy"
  }), _vm._v(" "), _c('span', [_vm._v("Ocupado limpio")])]), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "icon unclean-bussy"
  }), _vm._v(" "), _c('span', [_vm._v("Ocupado sucio")])]), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "icon clean-empty"
  }), _vm._v(" "), _c('span', [_vm._v("Vacías limpias")])]), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "icon unclean-empty"
  }), _vm._v(" "), _c('span', [_vm._v("Vacías sucias")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "pt-4": ""
    }
  }, _vm._l((_vm.bookings), function(booking) {
    return _c('housekeeping-card', {
      key: booking.id,
      attrs: {
        "image": booking.image,
        "roomNumber": booking.roomNumber,
        "roomTypeCode": booking.roomTypeCode,
        "lastname": booking.client.lastname,
        "name": booking.client.name,
        "startDate": booking.startDate,
        "endDate": booking.endDate,
        "currency": booking.currency,
        "bookingTotal": booking.bookingTotal,
        "bookingColor": booking.color
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79cb7982","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/housekeeping/List.vue
// module id = 1676
// module chunks = 57